import createCaseFirst from './_createCaseFirst.js';

/**
 * Converts the first character of `string` to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.lowerFirst('Fred');
 * // => 'fred'
 *
 * _.lowerFirst('FRED');
 * // => 'fRED'
 */
var lowerFirst = createCaseFirst('toLowerCase');

export default lowerFirst;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/lowerFirst.js
// module id = 453
// module chunks = 0